import { Link } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <div style={{ background: "var(--dark)" }}>
      <div
        className="container"
        style={{
          paddingTop: 26,
          paddingBottom: 40,
          borderTop: "1px solid rgba(250,245,238,.12)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "var(--on-dark-faint)",
          fontSize: 14,
          flexWrap: "wrap",
          gap: 14,
        }}
      >
        <Link to="/" className="site-footer__brand" style={{ textDecoration: "none" }}>
          <img src="/logo-psicodosis.png" alt="" />
          <span>PzicoDosis</span>
        </Link>
        <span>
          <Link to="/privacidad" style={{ color: "inherit", textDecoration: "none" }}>Privacidad</Link>
          {" · "}
          <Link to="/terminos" style={{ color: "inherit", textDecoration: "none" }}>Términos</Link>
          {" · Contacto · © "}{year}
        </span>
      </div>
    </div>
  );
}
